import { Art57Node } from "../Node/Art57Node/Art57Node";
import { FieldsErrorsControl } from "../FieldErrorsControl";
import { Section } from "./Section";
import { TreeNodeXEVPRMMessage } from "../Node/Art57Node/Entity/TreeNodeXEVPRMMessage";

export class ProductReportsSection extends Section {

    private fieldsErrorsControl = new FieldsErrorsControl();
    treeView: Art57Node[] = [];
    selectedNode!: Art57Node;

    getFieldsErrorsControl(): any {
        return this.fieldsErrorsControl;
    }

    override resetSection(): void {
        let xevprmMessage = this.ioc!.get(TreeNodeXEVPRMMessage);
        this.treeView = [];
        this.treeView.push(xevprmMessage);
        xevprmMessage.reset();
        this.selectedNode = xevprmMessage;
        this.getFieldsErrorsControl().resetFieldsFormControl(); // Reset error control 
    }

}
